<template>
  <div class="wizzard__form">
    <component
      v-bind="{ focusOnLoad }"
      :is="account.getFormName()"
      :instance="account"
      label="Property name"
      placeholder="Ex. 10 Beach Lane"
    />
    <component
      :is="asset.getFormDescription()"
      :instance="asset"
      label="Description"
      placeholder="Optional"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'

import { AssetClass } from '@types'

import { ASSET_FIELD } from '@/const'

type Props = {
  account: AssetClass
  asset: AssetClass
}

const props = defineProps<Props>()

defineOptions({ inheritAttrs: false })

const name = computed(() => props.account.field<string>(ASSET_FIELD.NAME).value)
const focusOnLoad = computed(() => !name.value)

watch(name, value => {
  props.account.field<string>(ASSET_FIELD.TICKER).value = value || ''
  const assetName = `${value} Property`
  props.asset.field<string>(ASSET_FIELD.NAME).value = assetName
  props.asset.field<string>(ASSET_FIELD.TICKER).value = assetName
})
</script>
